import type { WindowLocation } from '@reach/router';
import React, { use } from 'react';

import { WebsiteLink } from 'src/components/common/website-link';
import type { FacilityDetailsWithVideo } from 'src/components/facilities/facilities';
import { getUrlPathToClubFacility } from 'src/components/facilities/facilities';
import { SiteContext } from 'src/context/site-context';
import { isOnClubPage } from 'src/helpers/path-matching-helper';

import { FacilityImage } from './facility-image';

const wrapperClassNameForThumbnails = 'pa2 f5 w-12-rem h-8-rem';

export type FacilityProps = {
  facilityType: FacilityDetailsWithVideo;
  useSmallThumbnails: boolean;
  gtmTrackingId?: string;
  onClick?: () => void;
  isNav?: boolean;
};

const FacilityContent = ({
  facilityType,
  useSmallThumbnails,
  location,
  gtmTrackingId,
  onClick,
  isNav,
}: FacilityProps & { location: WindowLocation }) => {
  const facilityUrlPath = getUrlPathToClubFacility(facilityType);
  const { siteId, language, isDL } = use(SiteContext);
  const wrapperClassName = `club-facility pa3 w-50 fl f3 ${isDL ? 'new-design-club-facility' : ''}`;

  return (
    <div className={useSmallThumbnails ? wrapperClassNameForThumbnails : wrapperClassName}>
      {isOnClubPage(location, siteId, facilityUrlPath, language) ? (
        <div
          css={{ height: '100%', overflow: 'hidden', borderRadius: isDL ? 'unset' : '3px' }}
          className="facility"
        >
          <FacilityImage
            facilityType={facilityType}
            useSmallThumbnails={useSmallThumbnails}
            data-gtmid="current-page-facility"
            isNav={isNav}
          />
        </div>
      ) : (
        <div
          css={{
            overflow: 'hidden',
            height: '100%',
            width: '100%',
            borderRadius: isDL ? 'unset' : '3px',
            boxShadow: !isDL ? '0px 10px 20px 5px rgba(0, 0, 0, 0.1)' : undefined,
          }}
          className="facility"
        >
          <WebsiteLink
            to={facilityUrlPath}
            data-gtmid={gtmTrackingId || 'facility-link'}
            handleClick={onClick}
          >
            <FacilityImage
              facilityType={facilityType}
              useSmallThumbnails={useSmallThumbnails}
              isNav={isNav}
            />
          </WebsiteLink>
        </div>
      )}
    </div>
  );
};

export { FacilityContent };
